export const RolePermissions = {
  courseView: "course:view",
  courseEdit: "course:edit",
  rosterView: "roster:view",
  rosterEdit: "roster:edit",
  facultyView: "faculty:view",
  facultyEdit: "faculty:edit",
  degreeView: "degree:view",
  degreeEdit: "degree:edit",
  analyticsViewFaculty: "analytics:view:faculty",
  analyticsViewSchool: "analytics:view:school",
  wildcard: "*",
} as const;
